export const faqs = {
  marketingSite: {
    categories: [
      {
        title: "Program",
        faqs: [
          {
            answer:
              "Conceive is throwing the book at the established prenatal industry as the first digital company focused on actually changing outcomes and offering emotional support while doing it. Our mission is to get you pregnant as quickly as possible, while reducing your costs and minimizing your stress, and staying by your side through pregnancy and beyond. We help you figure out if you can get pregnant, then we do everything in our power to get you there and support you through it. We do this via two membership tiers—Plus and Premium—that cater to exactly the support level you need at this moment in your journey. We've got you.",
            question: "What is Conceive?",
          },
          {
            answer:
              "Your personal information is absolutely safe with us. We would never share your data without consent, and we would never (we repeat, never) sell your data. Everything you share with us will be kept strictly confidential. Making our members feel safe is central to everything we stand for.",
            question: "Will details I share be kept confidential?",
          },
          {
            answer:
              "Yes! Conceive is meant for anyone who is trying to conceive or pregnant—no matter what your journey looks like—whether that's through timed intercourse or assisted reproductive technology like IVF or IUI. We welcome everyone!",
            question: "What if I'm not interested in IVF, is Conceive for me?",
          },
          {
            answer:
              "No, we don't replace your doctors—we work with and alongside your medical team. We're by your side coaching and advising you through the process so you can make the most out of your doctor visits. That means making sure you ask the right questions and see the right set of providers. (We love recommending good docs to members!)",
            question: "Does Conceive replace visits with my doctor?",
          },
          {
            answer:
              "Premium members get a call/video chat with a coach a month, plus a nurse call/video chat and one financial coaching session. If you'd like purchase more, talk to your Conceive Care Team.",
            question:
              "How many calls or video chats do I get with my Care Team?",
          },
        ],
      },
      {
        title: "Premium",
        faqs: [
          {
            answer:
              "Our number one priority is getting everything right for you. While we match Premium members with crews on an ongoing basis, matching you with a crew that best suits your goals takes time. Please be patient with us as we work to find you the right group. In the meantime, you can take advantage of the other Premium benefits, such as 1:1 coaching and direct access to our team of medical experts.",
            question: "When will I be matched with my peer support group?",
          },
          {
            answer:
              "Your crew will consist of 6-9 other members and a coach who's been there, too. You are matched with your crew based on the responses you give on your initial member survey, plus your introductory screening call. Your crew and coach will meet over Zoom with the ability to message each other in between. These folks will become your new favorite group text, your village, your new best friends, your unwaivering support system—your people. (Truly, most of our members become friends with their crew IRL.) If, for whatever reason, your crew doesn't feel like exactly the right fit, we'll be on hand to find you a group that does.",
            question: "Who will be in my crew?",
          },

          {
            answer:
              "Your crew will meet over Zoom and group text. You will have the opportunity to join sessions led by experts, following a curriculum designed just for you. Your fellow crew members—who are made up of 6-9 peers on a similar journey—will be there to cheer you on, alongside a dedicated coach who has been in your shoes. It's like (fun) seminars on fertilty meets a support group of like-minded people who totally get it. The curriculum will give you the clarity you need to figure out what's going on and you'll come out of it with your \"[Un]Plan\" (a care plan with built-in flexibility for when things change), which will help you take action to feel that little bit more in calm and in control.",
            question: "What happens in a crew?",
          },
          {
            answer:
              "In order for the program to be the most effective for all of our members, we ask that you please try to engage as much as possible in the text groups and attend as many of the Zoom sessions as you are able. Of course, we know things come up and if they do, just let us know as soon as you can so we can accommodate you as best as possible.",
            question: "Is there a commitment to joining a crew?",
          },
        ],
      },
      {
        title: "Library",
        faqs: [
          {
            answer:
              "One of the benefits of Conceive membership is access to an expanded library of exclusive resources and materials with info that can really ramp-up your journey. That's why some articles are only accessible for members. Your best option if you'd like to read them is to sign up to a membership. You can explore your options here.",
            question: "Why are some articles locked?",
          },
        ],
      },
      {
        title: "Coaches & Experts",
        faqs: [
          {
            answer:
              "At Conceive, we choose our expert medical advisors from the very best in the fertility and prenatal industry—and they share their expertise directly with our members. Their focus areas include reproductive endocrinology and infertility, labor & delivery, embryology, nursing, genetic counseling, clinical social work, and traditional Eastern medicine.",
            question: "Who are the experts?",
          },
          {
            answer:
              "Our coaches act as approachable advocates and empathetic cheerleaders. They've all been through fertility journeys and pregnancies themselves, so they love to share personal insights where appropriate. They're supported by nurses and other clincians to make up an essential part of your wellbeing support-system.",
            question: "Who are the coaches?",
          },
          {
            answer:
              "Interested in becoming a Conceive coach or provider? We'd love to make that happen! Fill out our <CoachApplication>coach</CoachApplication> or <ProviderApplication>provider</ProviderApplication> application and we will be in touch.",
            question: "How do I become a Conceive coach or provider?",
          },
        ],
      },
      {
        title: "Billing",
        faqs: [
          {
            answer:
              "Conceive offers two membership tiers—Plus and Premium. Our Plus membership costs $49/month (less than two dollars a day) and Premium costs $129/month (less than a daily cup of coffee). Read more about what you get with each membership level on our <HowItWorks>how-it-works page</HowItWorks>.",
            question: "How much does Conceive cost?",
          },
          {
            answer:
              "Nope! You have two weeks before you're charged to feel it out. We want to make sure you're totally happy with the program. We call it our Two Week Wait Grace Period, just in case you find out you're pregnant or change your mind after joining.",
            question: "Will I be charged immediately?",
          },
          {
            answer:
              "Unfortunately, Conceive is not covered by insurance at this time. You may request a receipt for your Conceive program and check with your insurance provider or FSA/HSA provider to see if Conceive membership can be covered. We also have a financial advisor who is at the ready to give you tips on ways to save on your costs as part of your membership.",
            question: "Is Conceive covered by insurance?",
          },
          {
            answer:
              'We want you to be completely happy with your Conceive experience. If you need to cancel your subscription, you can do so at any time by clicking the icon in the upper right hand corner and going to the "Settings" page. Conceive offers a monthly auto-renewing subscription so you will continue to have access to your subscription through the end of the pay period.',
            question: "What if I want to cancel my Conceive membership?",
          },
        ],
      },
      {
        title: "General",
        faqs: [
          {
            answer:
              "Conceive is for adults 18 years of age and older. We want you to know that you're in control of your fertility journey, and when you choose to start is up to you.",
            question: "Am I too old or too young for Conceive?",
          },
          {
            answer:
              "In order to provide the best level of service, Conceive is currently available only to residents of the United States. We hope to grow globally in the not-too-distant future!",
            question: "Where is Conceive available?",
          },
          {
            answer:
              "We can help you with all the questions! Email us at <Email>support@weconceive.com</Email> with anything you need and we'll get right back to you.",
            question: "What if my question isn't answered here?",
          },
        ],
      },
    ],
  },
  memberSite: {
    categories: [
      {
        title: "Program",
        faqs: [
          {
            answer:
              "Your personal information is absolutely safe with us. We would never share your data without consent, and we would never (we repeat, never) sell your data. Everything you share with us will be kept strictly confidential. Of course if you ask us to share something, like with with your doctor for example, we're happy to. Making our members feel safe is central to everything we stand for.",
            question: "Will details I share be kept confidential?",
          },
          {
            answer:
              "No, we don't replace your doctors—we work with and alongside your medical team. We're by your side coaching and advising you through the process so you can make the most out of your doctor visits. That means making sure you ask the right questions and see the right providers. (We love recommending good docs to members!)",
            question: "Does Conceive replace visits with my doctor?",
          },
          {
            answer:
              "We work with our coaches, our team of medical experts, and industry-leading advisors to curate tasks and tips based on exactly where you're at in your journey. The more feedback you can give us the better, so we can make sure they're useful and get them juuuuust right. The point is to get you closer to meeting your goal with every task and tip—one baby step at a time.",
            question: "How are the items in my checklist selected for me?",
          },
          {
            answer:
              "We want to know! While our goal is to provide you with personalized tasks and tips designed for your fertility journey, if a task doesn't seem relevant, tell us, so we can get future ones right. To remove a task, click the 3 dots on the top right of a task card and—if you can—provide feedback on why it's not relevant. Every bit of feedback helps us make the Conceive experience that much better for you.",
            question: "What if my checklist tasks aren't relevant?",
          },
          {
            answer:
              'You can contact your coach any time by clicking "message coach" on your member dashboard. This takes you to a WhatsApp chat where you can DM them about anything and everything. But our coaches are so great about checking in and staying on top of your fertility journey we bet you may never even have to reach out first.',
            question: "How can I contact a coach?",
          },
          {
            answer: "<ResponseTimeQuestion />",
            question: "How quickly can I expect a response to my message?",
          },
          {
            answer:
              "Premium members get a call/video chat with a coach a month, plus a nurse call/video chat and one financial coaching session. If you'd like purchase more, talk to your Conceive Care Team. And if you'd like to upgrade from Plus to Premium, <SettingsLink>click here.</SettingsLink>",
            question:
              "How many calls or video chats do I get with my Care Team?",
          },
        ],
      },
      {
        title: "Premium",
        faqs: [
          {
            answer:
              "Our number one priority is getting everything right for you. While we match Premium members with crews on an ongoing basis, matching you with a crew that best suits your goals takes time. Please be patient with us as we work to find you the right group. In the meantime, you can take advantage of the other Premium benefits, such as 1:1 coaching and direct access to our team of medical experts.",
            question: "When will I be matched with my peer support group?",
          },
          {
            answer:
              "Your crew will consist of 6-9 other members and a coach who's been there, too. You are matched with your crew based on the responses you give on your initial member survey, plus your introductory screening call. Your crew and coach will meet over Zoom with the ability to message each other in between. These folks will become your new favorite group text, your village, your new best friends, your unwaivering support system—your people. (Truly, most of our members become friends with their crew IRL.) If, for whatever reason, your crew doesn't feel like exactly the right fit, we'll be on hand to find you a group that does",
            question: "Who will be in my crew?",
          },
          {
            answer:
              "Your crew will meet over Zoom and group text. You will have the opportunity to join sessions led by experts, following a curriculum designed just for you. Your fellow crew members—who are made up of 6-9 peers on a similar journey—will be there to cheer you on, alongside a dedicated coach who has been in your shoes. It's like (fun) seminars on fertilty meets a support group of like-minded people who totally get it. The curriculum will give you the clarity you need to figure out what's going on and you'll come out of it with your \"[Un]Plan\" (a care plan with built-in flexibility for when things change), which will help you take action to feel that little bit more in calm and in control.",
            question: "What happens in a crew?",
          },
          {
            answer:
              "In order for the program to be the most effective for all of our members, we ask that you please try to engage as much as possible in the text groups and attend as many of the Zoom sessions as you are able. Of course, we know things come up and if they do, just let us know as soon as you can so we can accommodate you as best as possible.",
            question: "Is there a commitment to joining a crew?",
          },
          {
            answer:
              "The curriculum was created by people who've spent way too much time (and energy and sanity) immersed in the world of infertility—through their own challenges, seeing others go through the process, and reading maybe one too many journal articles online. We worked closely with a diverse group of medical advisors from reproductive endocrinologists to doctors of Eastern medicine and licensed social workers. The curriculum synthesizes everything we wish we'd known in the trenches, while making it accessible and maybe even a little bit funny. We are always evidence-based where the data exists—and where there haven't been double-blind placebo trials yet, we will suggest next steps from our medical advisors (and tell you the difference!).",
            question: "How is the curriculum created?",
          },
          {
            answer:
              "Yes, we're more than happy to have you join another crew after you've finished yours. (Our members often have such a great experience with their crew that they're eager to join another.) As a Premium member, we can go right ahead and match you with another crew once your program has ended. Just let your coach know and we can take it from there.",
            question: "When I complete a crew can I join a new one?",
          },
          {
            answer:
              "We want you to feel just right in your crew. If yours doesn't seem like a fit, then reach out to your coach or email <Email>support@weconceive.com</Email> and we will work with you to find a better fitting crew.",
            question: "Can I switch my crew if it doesn't seem like a fit?",
          },
        ],
      },
      {
        title: "Library",
        faqs: [
          {
            answer:
              "The fertility world is your oyster! We are always expanding our library, so we welcome any suggestions or requests for topics to be covered. (Our Head of Content loves a good scoop.) Feel free to drop us a line at <Hello>hello@weconceive.com</Hello> with any ideas you have.",
            question:
              "What if there is a topic that I don't see covered in the library?",
          },
        ],
      },
      {
        title: "Coaches & Experts",
        faqs: [
          {
            answer:
              "At Conceive, we choose our expert medical advisors from the very best in the fertility and prenatal industry—and they share their expertise directly with our members. Their focus areas include reproductive endocrinology and infertility, labor & delivery, embryology, nursing, genetic counseling, clinical social work, and traditional Eastern medicine.",
            question: "Who are the experts?",
          },
          {
            answer:
              "Our coaches act as approachable advocates and empathetic cheerleaders. They've all been through fertility journeys and pregnancies themselves, so they love to share personal insights where appropriate. They're supported by nurses and other clincians to make up an essential part of your wellbeing support-system.",
            question: "Who are the coaches?",
          },
          {
            answer:
              "Interested in becoming a Conceive coach or provider? We'd love to make that happen! Fill out our <CoachApplication>coach</CoachApplication> or <ProviderApplication>provider</ProviderApplication> application and we will be in touch.",
            question: "How do I become a Conceive coach or provider?",
          },
        ],
      },
      {
        title: "Billing",
        faqs: [
          {
            answer:
              'You can upgrade, downgrade, or cancel your plan at any time. Simply click on the icon in the upper right corner of the site and select "Settings." Here you will see more information about your plan and can select to upgrade, downgrade, or cancel your current plan. If you\'re having any trouble, feel free to email us at <Email>support@weconceive.com</Email>.',
            question: "How can I upgrade, downgrade, or cancel my plan?",
          },
          {
            answer:
              "Unfortunately, Conceive is not covered by insurance at this time. You may request a receipt for your Conceive program and check with your insurance provider or FSA/HSA provider to see if Conceive membership can be covered. We also have a financial advisor who is at the ready to give you tips on ways to save on your costs as part of your membership.",
            question: "Is Conceive covered by insurance?",
          },
          {
            answer:
              'We want you to be completely happy with your Conceive experience. If you need to cancel your subscription, you can do so at any time by clicking the icon in the upper right hand corner and going to the "Settings" page. Conceive offers a monthly auto-renewing subscription so you will continue to have access to your subscription through the end of the pay period.',
            question: "What if I want to cancel my Conceive membership?",
          },
        ],
      },
      {
        title: "General",
        faqs: [
          {
            answer:
              "We can help you with all the questions! Email us at <Email>support@weconceive.com</Email> with anything you need and we'll get right back to you.",
            question: "What if my question isn't answered here?",
          },
        ],
      },
    ],
  },
};
